module.exports = __webpack_public_path__ + "img/imgSLOGAN-da.7f5c5642.png";